import { useSessionStore } from "@/stores/session.store";
import * as Sentry from "@sentry/vue";
import { watchEffect } from "vue";

export const useSentry = () => {
  const sessionStore = useSessionStore();
  watchEffect(() => {
    if (!Sentry.isInitialized()) return;
    // Access reactive state directly so watchEffect tracks the dependency
    const sessionIndex = sessionStore.selectedSessionIndex;
    const session =
      sessionIndex >= 0 ? sessionStore.sessions[sessionIndex] : null;
    const workspace = session?.workspaceUserGroup.workspace ?? null;
    const user = session?.workspaceUserGroup.user ?? null;
    if (user && workspace) {
      Sentry.setTag("workspace", workspace.id);
      Sentry.setUser({
        id: user.id,
        email: user.email,
        name: `${user.givenName} ${user.familyName}`
      });
    } else {
      Sentry.setUser(null);
    }
  });
};
